import styled from 'styled-components'
import DrawerComponent from 'react-modern-drawer'
import { white, black, purple, disabledGray, purpleSec } from 'theme/colors'

export const Drawer = styled(DrawerComponent)`
  width: 417px !important;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px 0px 48px;
  gap: 30px;
  width: 417px;
  height: 100%;
  background: ${white};
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 65px 20px 0px 20px;
  gap: 11px;
  width: 417px;
  height: 131px;
  background: ${white};
  position: relative; 
`

export const BackButton = styled.button`
  width: 27.07px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`

export const Title = styled.h2`
  width: 355.87px;
  height: 31px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 154.7%;
  text-align: center;
  color: ${black};
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 42px;
  width: 417px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 35px;
  width: 417px;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 417px;
`

export const InfoLabel = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${disabledGray};
  margin: 0 0 4px 0;
`

export const InfoValue = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  color: ${black};
  margin: 0;
`

export const MessageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 40px;
  width: 417px;
  margin-top: auto;
`

export const MessageText = styled.p`
  width: 417px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #666666;
  margin: 0;
  padding: 0 20px;
`

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: 16px;
  width: 232px;
`

export const ActionButton = styled.button`
  width: 232px;
  height: 53px;
  background: ${purple};
  border-radius: 6px;
  border: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  color: ${white};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background: #d3d3d3;
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:disabled:hover {
    opacity: 0.6;
  }
`

export const CancelButton = styled.button`
  width: 232px;
  height: 53px;
  background: ${purpleSec};
  border-radius: 6px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  color: ${purple};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`
